import { Component, OnInit } from '@angular/core';
import { GlobalUtilsService } from 'src/app/global-utils.service';

@Component({
  selector: 'app-bottom-copyright',
  template: `
    <div
      class="vertical-copyright-wrap"
      [ngClass]="{ mobile: globalUtilsService.isMobile() }"
    >
      <p>
        © Copyright {{ currentDate | date: 'yyyy' }} Paraíso Fotovoltaico. Todos os
        direitos reservados.
      </p>
      <a target="_blank" href="https://silvanohebert.com.br/">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.455 13">
          <path
            d="M8.459,3.347H6.939v3.07l-4.2-2.572a.628.628,0,0,1-.249-.5V2.489H4.727V0H2.018A2.012,2.012,0,0,0,0,2.019V8.243L2.488,9.764v-3.1l4.23,2.572a.616.616,0,0,1,.249.47v.111a.685.685,0,0,1-.691.691H4.727V13H7.436a2.03,2.03,0,0,0,2.018-2.019V4.315A1,1,0,0,0,8.459,3.347Z"
            fill="#fff"
          />
        </svg>
      </a>
    </div>
  `,
  styles: [
    `
      .vertical-copyright-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      a {
        align-self: flex-end;
      }

      svg {
        display: block;
        width: 0.42rem;
      }

      svg path {
        fill: #000000;
      }

      p {
        font-size: 0.53rem;
        margin: 0;
        padding: 0;
        opacity: 0.5;
        color: black;
        font-weight: 800;
        width: 12rem;
      }

      .vertical-copyright-wrap.mobile {
        align-items: flex-end;
      }

      .vertical-copyright-wrap.mobile p {
        color: white;
        font-size: 0.4rem;
        width: 5rem;
        line-height: 175%;
      }

      .vertical-copyright-wrap.mobile svg {
        display: block;
        width: 0.35rem;
      }

      .vertical-copyright-wrap.mobile svg path {
        fill: #ffffff;
      }
    `,
  ],
})
export class BottomCopyrightComponent implements OnInit {
  currentDate: Date;

  constructor(public globalUtilsService: GlobalUtilsService) {
    this.currentDate = new Date();
  }

  ngOnInit() {}
}
